import ApplicationController from './application_controller';
import initializeDataTable from '../lib/datatables/initialize';

export default class extends ApplicationController {
  static targets = [
    'serviceHistoryDataTable'
  ];

  static values = { dataTablesLoaded: Boolean };

  initialize() {
    this.dataTablesLoaded = false;
  }

  initDataTables() {
    if (!this.dataTablesLoaded) {
      this.setDataTables();
      this.dataTablesLoaded = true;
    }
  }

  serviceHistoryDataTableTargetConnected() {
    this.initDataTables();
    if (window.$.fn.DataTable.isDataTable('#service-history-table')) {
      window.$('#service-history-table').DataTable().destroy();
    }
    window.$('#service-history-table').DataTable({
      order: [[0, 'desc']],
    });
  }

  setDataTables() {
    // Method relies on $ and moment defined on window which comes from the caseloads pack
    function strip(d) {
      if (typeof d === 'string') {
        // Strip HTML tags and newline characters if possible
        d = d.replace(/(<.*?>)|(\r?\n|\r)/g, ''); // Strip out surrounding white space

        d = d.trim();
      }

      return d;
    }

    window.$.fn.dataTable.moment = function (format, locale, reverseEmpties) {
      const types = window.$.fn.dataTable.ext.type; // Add type detection

      types.detect.unshift((d) => {
        d = strip(d); // Null and empty values are acceptable

        if (d === '' || d === null) {
          return 'moment-' + format;
        }

        return moment(d, format, locale, true).isValid() ? 'moment-' + format : null;
      }); // Add sorting method - use an integer for the sorting

      types.order['moment-' + format + '-pre'] = function (d) {
        d = strip(d);
        return !moment(d, format, locale, true).isValid() ? reverseEmpties ? -Infinity : Infinity : parseInt(moment(d, format, locale, true).format('x'), 10);
      };
    };
  }
}
